/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

export type PartnerAccountPermissionsValue = {
  success: boolean | null;
  errorMessage: string;
};

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [PartnerAccountPermissionsValue, (_params: vp.AccountPermissionRequest) => void, () => void];

function usePostPartnerAccountPermissions({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.AccountPermissionRequest | null>(null);
  const [response, setResponse] = useState<PartnerAccountPermissionsValue>({ success: null, errorMessage: '' });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (Permissions: vp.AccountPermissionRequest) => {
      setDataFetchingInfo(true, 'saving permissions', 'fullScreen');

      const { Success, ErrorMessage } = await api.postPartnerAccountPermissions(Permissions, source);

      setResponse({ success: Success, errorMessage: ErrorMessage });
      setSendRequest(false);
      setDataFetchingInfo(false);
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.AccountPermissionRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setParams({});
      setResponse({ success: null, errorMessage: '' });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPartnerAccountPermissions);
